//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../Motion/Motion.SelectLink.js";
import "../Motion/Motion.SelectFieldData.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"ActionCsys",1,"CoordinateSystem",0],[0,"ActionCsysOvrCtrl",1,0],[1,"ActionLink",0,"Motion.SelectLink",0],[0,"ActionLinkOvrCtrl",1,0],[0,"ActionPoint",1,"Point",0],[0,"ActionPointOvrCtrl",1,0],[0,"Apptype",1,0],[0,"Direction",1,0],[0,"Function",1,"CAE.Function",0],[0,"Name",1,0],[1,"Profile",0,"Motion.SelectFieldData",0],[0,"ReactionCsys",1,"CoordinateSystem",0],[0,"ReactionCsysOvrCtrl",1,0],[1,"ReactionLink",0,"Motion.SelectLink",0],[0,"ReactionLinkOvrCtrl",1,0],[0,"ReactionPoint",1,"Point",0],[0,"ReactionPointOvrCtrl",1,0],[1,"ValueExpression",0,"Expression",0],[0,"ValueType",1,0]],[],[]];
SPLM.Motion.ScalarForceBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.ScalarForceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.ScalarForceBuilder.DirectionType = Object.freeze({
    "Translational" : "Translational", "X" : "X", "Y" : "Y", "Z" : "Z"});

SPLM.Motion.ScalarForceBuilder.ApplyType = Object.freeze({
    "ActionReaction" : "ActionReaction", "ActionOnly" : "ActionOnly"});

export default SPLM;